module.exports = __webpack_public_path__ + "static/img/user-pick-propmotion-banner.8e95e82.png";